export class DiscoveredUsFrom {
	id:number = 0;
	google:boolean = false;
	facebook:boolean = false;
	instagram:boolean = false;
	otherSocialMedia:boolean = false;
	friendOracquaintance:boolean = false;
	myAccountant:boolean = false;
	other:boolean = false;

	public constructor(data?:any){
		if (!data) return;
		this.id = data.ID;
		this.google = data.Google;
		this.facebook = data.Facebook;
		this.instagram = data.Instagram;
		this.otherSocialMedia = data.OtherSocialMedia;
		this.friendOracquaintance = data.FriendOracquaintance;
		this.myAccountant = data.MyAccountant;
		this.other = data.Other;
	}

	public getJSON(){
		return {
			ID: this.id,
			Google: this.google,
			Facebook: this.facebook,
			Instagram: this.instagram,
			OtherSocialMedia: this.otherSocialMedia,
			FriendOracquaintance: this.friendOracquaintance,
			MyAccountant: this.myAccountant,
			Other: this.other,
		};
	}

	isEmpty():boolean{
		if (this.google){
			return false;
		}
		if (this.facebook){
			return false;
		}
		if (this.instagram){
			return false;
		}
		if (this.otherSocialMedia){
			return false;
		}
		if (this.friendOracquaintance){
			return false;
		}
		if (this.myAccountant){
			return false;
		}
		if (this.other){
			return false;
		}
		return true;
	}

	getItemsAsStringArray():string[]{
		let result:string[] = [];
		if (this.google){
			result.push("Google");
		}
		if (this.facebook){
			result.push("Facebook");
		}
		if (this.instagram){
			result.push("Instagram");
		}
		if (this.otherSocialMedia){
			result.push("Andere sociale media");
		}
		if (this.friendOracquaintance){
			result.push("Vriend of kennis");
		}
		if (this.myAccountant){
			result.push("Mijn accountant");
		}
		if (this.other){
			result.push("Andere");
		}
		return result;
	}
}